// src/App.js (Versión Completa y Funcional con Búsqueda)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { SearchProvider } from './context/SearchContext'; // Importamos el nuevo proveedor
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import StreetRangesPage from './pages/StreetRangesPage';
import FirmsPage from './pages/FirmsPage';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#0083BF' },
    background: { default: '#002348', paper: '#072C48' },
  },
});

const RootRedirect = () => {
  const { token } = useAuth();
  return token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AuthProvider>
        <NotificationProvider>
          <SearchProvider>
            <Router>
              <Routes>
                {/* Rutas Públicas */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                
                {/* Rutas Protegidas */}
                <Route 
                  path="/dashboard/*"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <Routes>
                           <Route path="/" element={<DashboardPage />} />
                           <Route path="/street-ranges" element={<StreetRangesPage />} />
                           <Route path="/firms" element={<FirmsPage />} />
                        </Routes>
                      </Layout>
                    </ProtectedRoute>
                  } 
                />

                {/* Redirección desde la raíz */}
                <Route path="/" element={<RootRedirect />} />
              </Routes>
            </Router>
          </SearchProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
